.container {
  display: flex;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
}

.main {
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.header {
  font-style: normal;
  color: var(--static-text-strong);
  font-weight: 500;
  line-height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-transform: capitalize;
}

.headerMain {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.pageContainer {
  background: var(--static-background-weak);
  width: 100%;
  min-height: 100vh;
}

.mobileNotSupportedContainer {
  display: none;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
  background-color: var(--static-background-strong);
  padding: 4rem 2rem;
  box-sizing: border-box;
}

.logo {
  color: var(--color-primary);
  margin-bottom: 2.5rem;
}

.notSupportedMessageContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

.notSupportedMessageText {
  color: var(--static-color-standard);
  font-size: 1.75rem;
  margin-bottom: 20px;
}

.logoutButton {
  width: 100%;
  margin-top: 2.5rem;
}

@media screen and (max-width: 430px) {
  .container {
    display: none;
  }
  .mobileNotSupportedContainer {
    display: flex;
  }
}